import { render, staticRenderFns } from "./Fantasiewoerter.vue?vue&type=template&id=23cd5d56"
import script from "./Fantasiewoerter.vue?vue&type=script&lang=ts"
export * from "./Fantasiewoerter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports